import { render, staticRenderFns } from "./buyUOrder.vue?vue&type=template&id=fd7f17be&scoped=true"
import script from "./buyUOrder.vue?vue&type=script&lang=ts"
export * from "./buyUOrder.vue?vue&type=script&lang=ts"
import style0 from "./buyUOrder.vue?vue&type=style&index=0&id=fd7f17be&prod&lang=scss"
import style1 from "./buyUOrder.vue?vue&type=style&index=1&id=fd7f17be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7f17be",
  null
  
)

export default component.exports